import mitt, { EventType, Handler } from "mitt";

export type VueEventEmitterFacade<Events> = {
  $on: <Key extends keyof Events>(
    type: Key,
    handler: Handler<Events[Key]>
  ) => void;
  $off: <Key extends keyof Events>(
    type: Key,
    handler: Handler<Events[Key]>
  ) => void;
  $emit: <Key extends keyof Events>(type: Key, event: Events[Key]) => void;
};

export const createEventEmitter = <
  Events extends Record<EventType, unknown>
>(): VueEventEmitterFacade<Events> => {
  const emitter = mitt<Events>();

  return {
    $on: <Key extends keyof Events>(
      type: Key,
      handler: Handler<Events[Key]>
    ): void => emitter.on(type, handler),
    $off: <Key extends keyof Events>(
      type: Key,
      handler: Handler<Events[Key]>
    ): void => emitter.off(type, handler),
    $emit: <Key extends keyof Events>(type: Key, event: Events[Key]) =>
      emitter.emit(type, event)
  };
};
